// extracted by mini-css-extract-plugin
export default {"container":"oq-z","heading":"pq-z","text":"qq-z","info":"rq-z","link":"sq-z","fullMaxWidth":"tq-z"};